import { StringConstantsMixin } from '../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const {
  strings: {
    PRIVACY_POLICY: {
      ACTIVITIES_LABEL,
      ACTIVITY_PRIVACY,
      ANYTIME_YOU_USE_NAVIGATOR,
      CHOOSE_WHO_CAN_VIEW_THIS_ACTIVITY,
      CHOOSE_WHO_CAN_VIEW_THIS_MAP,
      COMPLETED_TRAILS_LABEL,
      DO_NOT_REQUIRE_FOLLOWER_REQUESTS,
      FOLLOWERS_ONLY,
      LIST_PRIVACY,
      MAP_PRIVACY,
      NO,
      NOTE_PRIVACY_LEVEL_ACTIVITY,
      NOTE_PRIVACY_LEVEL_MAPS,
      ONLY_ME,
      PUBLIC,
      REQUIRE_FOLLOW_REQUESTS,
      REQUIRE_FOLLOWER_REQUESTS,
      THE_LISTS_YOU_CREATE,
      THIS_INCLUDES_MAPS_CREATED_DOWNLOADED,
      THIS_MAP_VISIBLE_ANYONE,
      THIS_MAP_VISIBLE_FOLLOWERS,
      THIS_MAP_VISIBLE_YOU,
      YES,
      YOU_CAN_ALWAYS_CHANGE_THE_PRIVACY,
      YOUR_ACTIVITIES_VISIBLE_ANYONE,
      YOUR_ACTIVITIES_VISIBLE_FOLLOWERS,
      YOUR_ACTIVITIES_VISIBLE_YOU,
      THIS_ACTIVITY_VISIBLE_ANYONE,
      THIS_ACTIVITY_VISIBLE_FOLLOWERS,
      THIS_ACTIVITY_VISIBLE_YOU,
      YOUR_COMMUNITY_INCLUDES,
      YOUR_COMMUNITY_IS_VISIBLE_ANYONE,
      YOUR_COMMUNITY_IS_VISIBLE_FOLLOWERS,
      YOUR_COMMUNITY_VISIBLE_YOU,
      YOUR_COMMUNITY,
      YOUR_COMPLETED_TRAILS_DO_NOT_INCLUDE,
      YOUR_COMPLETED_TRAILS_VISIBLE_ANYONE,
      YOUR_COMPLETED_TRAILS_VISIBLE_FOLLOWERS,
      YOUR_COMPLETED_TRAILS_VISIBLE_YOU,
      YOUR_LISTS_VISIBLE_ANYONE,
      YOUR_LISTS_VISIBLE_FOLLOWERS,
      YOUR_LISTS_VISIBLE_YOU,
      YOUR_MAPS_VISIBLE_ANYONE,
      YOUR_MAPS_VISIBLE_FOLLOWERS,
      YOUR_MAPS_VISIBLE_YOU,
      CHOOSE_WHO_CAN_VIEW_THIS_LIST,
      THIS_LIST_VISIBLE_ANYONE,
      THIS_LIST_VISIBLE_FOLLOWERS,
      THIS_LIST_VISIBLE_YOU
    },
    CONVERTER: { CONVERTER_SUCCESS },
    NAVIGATION
  }
} = StringConstantsMixin;

const doubleBreak = (
  <>
    <br />
    <br />
  </>
);
// privacy policy visibility options
export const VISIBILITY_PUBLIC = 'urn:alltrails:visibility:public';
export const VISIBILITY_FOLLOWERS_ONLY = 'urn:alltrails:visibility:followers-only';
export const VISIBILITY_PRIVATE = 'urn:alltrails:visibility:private';
export const TRUE = true;
export const FALSE = false;

const VISIBILITY_ARRAY = [VISIBILITY_PUBLIC, VISIBILITY_FOLLOWERS_ONLY, VISIBILITY_PRIVATE];

export const VISIBILITY_TO_OPTION = {
  [VISIBILITY_PUBLIC]: PUBLIC,
  [VISIBILITY_FOLLOWERS_ONLY]: FOLLOWERS_ONLY,
  [VISIBILITY_PRIVATE]: ONLY_ME,
  [TRUE]: YES,
  [FALSE]: NO
};

// privacy policy subjects
export const COMPLETED_TRAILS = 'completedTrails';
export const ACTIVITIES = 'activities';
export const ACTIVITY = 'activity';
export const CUSTOM_MAPS = 'customMaps';
export const CUSTOM_MAP = 'customMap';
export const LISTS = 'lists';
export const SOCIAL_NETWORK = 'socialNetwork';
export const FOLLOW_REQUESTS_REQUIRED = 'followRequestsRequired';
export const LIST = 'list';

export const SUBJECT_TO_TITLE = {
  [FOLLOW_REQUESTS_REQUIRED]: REQUIRE_FOLLOWER_REQUESTS,
  [SOCIAL_NETWORK]: YOUR_COMMUNITY,
  [COMPLETED_TRAILS]: COMPLETED_TRAILS_LABEL,
  [ACTIVITIES]: ACTIVITIES_LABEL,
  [CUSTOM_MAPS]: CONVERTER_SUCCESS.MAPS,
  [LISTS]: NAVIGATION.LISTS,
  [CUSTOM_MAP]: MAP_PRIVACY,
  [ACTIVITY]: ACTIVITY_PRIVACY,
  [LIST]: LIST_PRIVACY
};

export const PRIVACY_POLICY_KEYS_MAP = {
  [FOLLOW_REQUESTS_REQUIRED]: ['socialNetwork', 'followRequestsRequired'],
  [SOCIAL_NETWORK]: ['profile', 'visibility'],
  [COMPLETED_TRAILS]: ['content', 'visibility'],
  [ACTIVITIES]: ['content', 'visibility'],
  [CUSTOM_MAPS]: ['content', 'visibility'],
  [LISTS]: ['content', 'visibility']
};

const generateRadioProps = (title, description, selected, subtexts) => {
  return {
    title,
    description,
    selected,
    radioOptions: subtexts.map((subtext, idx) => {
      return {
        id: VISIBILITY_TO_OPTION[VISIBILITY_ARRAY[idx]],
        name: VISIBILITY_TO_OPTION[VISIBILITY_ARRAY[idx]],
        title: VISIBILITY_TO_OPTION[VISIBILITY_ARRAY[idx]],
        subtext,
        value: VISIBILITY_ARRAY[idx]
      };
    })
  };
};

export const policyToRadioForm = (subject, selected) => {
  const title = SUBJECT_TO_TITLE[subject];

  switch (subject) {
    case FOLLOW_REQUESTS_REQUIRED:
      return {
        title,
        description: YOUR_COMMUNITY_INCLUDES,
        selected,
        radioOptions: [
          {
            id: VISIBILITY_TO_OPTION[FALSE],
            name: VISIBILITY_TO_OPTION[FALSE],
            title: VISIBILITY_TO_OPTION[FALSE],
            subtext: DO_NOT_REQUIRE_FOLLOWER_REQUESTS,
            value: FALSE.toString()
          },
          {
            id: VISIBILITY_TO_OPTION[TRUE],
            name: VISIBILITY_TO_OPTION[TRUE],
            title: VISIBILITY_TO_OPTION[TRUE],
            subtext: REQUIRE_FOLLOW_REQUESTS,
            value: TRUE.toString()
          }
        ]
      };
    case SOCIAL_NETWORK:
      return generateRadioProps(title, YOUR_COMMUNITY_INCLUDES, selected, [
        YOUR_COMMUNITY_IS_VISIBLE_ANYONE,
        YOUR_COMMUNITY_IS_VISIBLE_FOLLOWERS,
        YOUR_COMMUNITY_VISIBLE_YOU
      ]);
    case COMPLETED_TRAILS:
      return generateRadioProps(title, YOUR_COMPLETED_TRAILS_DO_NOT_INCLUDE, selected, [
        YOUR_COMPLETED_TRAILS_VISIBLE_ANYONE,
        YOUR_COMPLETED_TRAILS_VISIBLE_FOLLOWERS,
        YOUR_COMPLETED_TRAILS_VISIBLE_YOU
      ]);
    case ACTIVITIES:
      return generateRadioProps(
        title,
        <div>
          {ANYTIME_YOU_USE_NAVIGATOR} {doubleBreak} {NOTE_PRIVACY_LEVEL_ACTIVITY}
        </div>,
        selected,
        [YOUR_ACTIVITIES_VISIBLE_ANYONE, YOUR_ACTIVITIES_VISIBLE_FOLLOWERS, YOUR_ACTIVITIES_VISIBLE_YOU]
      );
    case CUSTOM_MAPS:
      return generateRadioProps(
        title,
        <div>
          {THIS_INCLUDES_MAPS_CREATED_DOWNLOADED} {doubleBreak} {NOTE_PRIVACY_LEVEL_MAPS}
        </div>,
        selected,
        [YOUR_MAPS_VISIBLE_ANYONE, YOUR_MAPS_VISIBLE_FOLLOWERS, YOUR_MAPS_VISIBLE_YOU]
      );

    case LISTS:
      return generateRadioProps(
        title,
        <div>
          {THE_LISTS_YOU_CREATE} {doubleBreak} {YOU_CAN_ALWAYS_CHANGE_THE_PRIVACY}
        </div>,
        selected,
        [YOUR_LISTS_VISIBLE_ANYONE, YOUR_LISTS_VISIBLE_FOLLOWERS, YOUR_LISTS_VISIBLE_YOU]
      );
    case LIST:
      return generateRadioProps(title, CHOOSE_WHO_CAN_VIEW_THIS_LIST, selected, [
        THIS_LIST_VISIBLE_ANYONE,
        THIS_LIST_VISIBLE_FOLLOWERS,
        THIS_LIST_VISIBLE_YOU
      ]);
    case CUSTOM_MAP:
      return generateRadioProps(title, CHOOSE_WHO_CAN_VIEW_THIS_MAP, selected, [
        THIS_MAP_VISIBLE_ANYONE,
        THIS_MAP_VISIBLE_FOLLOWERS,
        THIS_MAP_VISIBLE_YOU
      ]);
    case ACTIVITY:
      return generateRadioProps(title, CHOOSE_WHO_CAN_VIEW_THIS_ACTIVITY, selected, [
        THIS_ACTIVITY_VISIBLE_ANYONE,
        THIS_ACTIVITY_VISIBLE_FOLLOWERS,
        THIS_ACTIVITY_VISIBLE_YOU
      ]);
    default:
      return null;
  }
};
